import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  gap: 20px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 14px;
    font-weight: 500;
    color: #424248;
    span {
      color: red;
    }
  }
`;
